import {useQuery} from "react-query";
import {useParams} from "react-router-dom";
import api from "../services/api";

const fetchPlayerData = (timing) => {
    return api.get(`/timings/${timing}/data`).then(response => response.data && response.data.data);
}

const useFetchPlayerData = () => {
    const { timing } = useParams();

    return useQuery([timing, 'player-data'], () => fetchPlayerData(timing));
};

export default useFetchPlayerData;
